export default [
  {
    id: 1,
    name: 'Susana',
  },
  {
    id: 2,
    name: 'Natalia',
  },
  {
    id: 3,
    name: 'Romina',
  },
  {
    id: 4,
    name: 'Leonel',
  },
];
